<template>
	<div>
		

		<template v-if="headerShow">
			<div class="sqzxOne">
			<div class="sqzxOneFor" v-for="(item, index) in shfwList" :key="index">
				<div class="sqzxOneForImg">
					<img :src="item.icon" />
				</div>
				<div class="sqzxOneForName">
					{{ item.title }}
				</div>
				<div class="sqzxOneForCen">
					{{ item.desc }}
				</div>
				<div class="sqzxOneForXian" v-if="index !== shfwList.length - 1">
					<div></div>
				</div>
			</div>
		</div></template>
		<template v-else>
			<div class="sqzxOne">
			<div class="sqzxOneFor" :class="shfwList.length - 1 !== index?'sqzxOneForBottom':''" v-for="(item, index) in shfwList" :key="index">
				<div class="sqzxOneForImg">
					<img :src="item.icon" />
				</div>
				<div class="sqzxOneForName">
					{{ item.title }}
				</div>
				<div class="sqzxOneForCen">
					{{ item.desc }}
				</div>
				<div class="sqzxOneForXian" v-if="index !== shfwList.length - 1">
					<div></div>
				</div>
			</div>
		</div>
		</template>

	</div>
</template>

<script>
import {
	get_en_contact_us_service
} from '@/api/contact.js'
export default {
	components: {

	},
	data() {
		return {
			shfwList: []
		}
	},
	mounted() {
		this.getShfw();
	},
	methods: {
		getShfw() {
			let data = {}
			get_en_contact_us_service(data).then(res => {
				console.log(res)
				this.shfwList = res.data;
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style></style>
<style scoped lang="scss">
.sqzxOne {
	width: 1200px;
	margin: 0 auto;
	background: #fafafa;
	display: flex;
	justify-content: center;
	height: 400px;
	margin-bottom: 150px;
	// .sqzxOneFor:first-child{
	// 	border-right: 2px solid #AFAFAF;
	// }
	position: relative;



	.sqzxOneFor {
		width: 600px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		position: relative;
		z-index: 2;

		.sqzxOneForXian {
			position: absolute;
			top: 0;
			right: 0;
			z-index: 1;
			height: 100%;
			display: flex;
			align-items: center;

			>div {
				width: 2px;
				height: 200px;
				background: #AFAFAF;
			}
		}

		.sqzxOneForImg {
			img {
				width: 120px;
				height: 120px;
			}
		}

		.sqzxOneForName {
			font-size: 23px;
			
			font-weight: 500;
			color: #000000;
			margin-top: 30px;
		}

		.sqzxOneForCen {
			margin-top: 16px;
			font-size: 23px;
			
			font-weight: 400;
			color: #000000;
		}
	}
}


@media screen and (max-width:1200px) {
	.sqzxOne {
		width: 100% !important;
		// background: red !important;
		display: block !important;
		height: auto !important;
		margin-bottom: 0px !important;

		.sqzxOneForBottom {
			border-bottom: 2px solid #eeeeee;
		}

		.sqzxOneFor {
			width: 100% !important;
			padding-bottom: 10px !important;
			box-sizing: border-box;

			.sqzxOneForName {
				// margin-top: 10px !important;
				font-size: 20px !important;
			}

			.sqzxOneForCen {
				font-size: 18px !important;
			}

			.sqzxOneForXian {
				display: none;
			}
		}
	}
}
</style>
